import { Scissors, Sprout, Mountain, Droplets, ShieldCheck, Wrench } from "lucide-react";

// Icons stay fixed by section index (design constant). Text content is editable
// via the admin portal and served from /api/content.
export const SERVICE_ICONS = [Scissors, Sprout, Mountain, Droplets];

export const FOUNDER_META = [
  {
    icon: ShieldCheck,
    img: "/adrian.jpg",
  },
  {
    icon: Wrench,
    img: "/david.jpg",
  },
];

export const SERVICE_OPTIONS = [
  "Lawn Maintenance",
  "Mowing",
  "Edging",
  "Weed Eating",
  "Blowing Sidewalks & Porches",
  "Plant Installation",
  "Shrubs & Trees",
  "Stone Borders",
  "Small Rock Projects",
  "Drainage Solutions",
  "French Drains",
  "Dry Creek Beds",
  "Multiple / Not Sure",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1713789327173-fe5450ec66d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxwZXJmZWN0JTIwZ3JlZW4lMjBsYXduJTIwbGFuZHNjYXBpbmclMjBob3VzZXxlbnwwfHx8fDE3ODE2NTk2NDJ8MA&ixlib=rb-4.1.0&q=85",
  founders: "/founders-both.jpg",
  stone: "https://images.unsplash.com/photo-1619377472056-fc05725278ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzdG9uZSUyMHBhdGh3YXklMjBsYW5kc2NhcGluZyUyMGdhcmRlbnxlbnwwfHx8fDE3ODE2NTk2NDN8MA&ixlib=rb-4.1.0&q=85",
  lawn: "https://images.unsplash.com/photo-1576897955702-24ad19680db3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwZXJmZWN0JTIwZ3JlZW4lMjBsYXduJTIwbGFuZHNjYXBpbmclMjBob3VzZXxlbnwwfHx8fDE3ODE2NTk2NDJ8MA&ixlib=rb-4.1.0&q=85",
};

// Default text content — mirrors the backend DEFAULT_CONTENT so the site renders
// instantly before the API responds, and as a fallback if it fails.
export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Veteran-Owned · Family-Built",
    titleLine1: "Growing More Than Lawns.",
    titleHighlight: "Building a Legacy.",
    subtext:
      "Professional lawn care and landscaping for Rincon, Springfield, Guyton, Pooler, and surrounding communities — done with the care of a family that takes pride in every cut.",
  },
  contact: {
    phone: "(314) 386-6993",
    email: "info@legacylawnlandscapellc.com",
    hours: "Mon–Sat, 7:00 AM – 6:00 PM",
    areaLine: "Rincon · Springfield · Guyton · Pooler & surrounding communities",
    serviceAreas: ["Rincon", "Springfield", "Guyton", "Pooler", "Surrounding Areas"],
  },
  services: [
    {
      group: "Lawn Maintenance",
      blurb: "Reliable, scheduled care that keeps your property sharp all season long.",
      items: [
        { name: "Lawn Maintenance", desc: "Full-service upkeep on a schedule you can count on." },
        { name: "Mowing", desc: "Crisp, even cuts that keep your turf healthy and uniform." },
        { name: "Edging", desc: "Clean, defined lines along drives, walks, and beds." },
        { name: "Weed Eating", desc: "Detailed trimming where the mower can't reach." },
        { name: "Blowing Sidewalks & Porches", desc: "Every job ends with a clean, finished property." },
      ],
    },
    {
      group: "Plant Installation",
      blurb: "Thoughtful planting that adds curb appeal and grows in value year after year.",
      items: [
        { name: "Plant Installation", desc: "The right plants, placed to thrive in your yard." },
        { name: "Shrubs & Trees", desc: "Hand-selected and properly planted for lasting growth." },
      ],
    },
    {
      group: "Hardscaping",
      blurb: "Stonework and rock projects built with craftsmanship and built to last.",
      items: [
        { name: "Stone Borders", desc: "Durable, handsome borders that frame your landscape." },
        { name: "Small Rock Projects", desc: "Accents and features that add texture and character." },
      ],
    },
    {
      group: "Drainage Solutions",
      blurb: "Practical water management that protects your yard, foundation, and investment.",
      items: [
        { name: "Drainage Solutions", desc: "Custom plans to move water away from where it shouldn't be." },
        { name: "French Drains", desc: "Engineered subsurface drainage for soggy problem areas." },
        { name: "Dry Creek Beds", desc: "Functional drainage that doubles as a beautiful feature." },
      ],
    },
  ],
  founders: [
    {
      name: "Adrian",
      role: "Co-Founder · The Foundation",
      quote: "Do it right the first time, or don't do it at all.",
      bio: "A veteran with a builder's discipline, Adrian sets the standard for how every job gets done. He brings decades of grit, a steady hand, and an unshakable belief that hard work and integrity never go out of style.",
    },
    {
      name: "David",
      role: "Co-Founder · The Future",
      quote: "We're not just cutting grass — we're building something that lasts.",
      bio: "David carries the family vision forward, blending modern landscaping craft with the values his father instilled. He's hands-on with every project and obsessed with the details that turn a good yard into a great one.",
    },
  ],
};

// Convenience fallbacks
export const CONTACT = DEFAULT_CONTENT.contact;
export const SERVICE_AREAS = DEFAULT_CONTENT.contact.serviceAreas;
